export default function initCart(): void {
    document.addEventListener('DOMContentLoaded', () => {
        const $container = document.querySelector<HTMLElement>('.certigna-cart-container');
        if (!$container) {
            return;
        }

        const $quantitySelects = document.querySelectorAll('.certigna-cart-product-quantity select');
        const $WooFormCartButtton = document.querySelector('.woocommerce-cart-form .shop_table .actions button') as HTMLButtonElement; 

        $quantitySelects.forEach(($quantitySelect) => {
            $quantitySelect.addEventListener('change', (event) => {
                const select = event.target as HTMLSelectElement;
                if (select && select.closest('.certigna-cart-product-quantity')) {
                    const $WooQuantityInput = document.querySelector('.woocommerce-cart-form input[name="'+select.name+'"]') as HTMLInputElement;
                    const $WooFormCartButton = document.querySelector('.woocommerce-cart-form .shop_table .actions button') as HTMLButtonElement;

                    if ($WooQuantityInput && $WooFormCartButton) {
                        $WooQuantityInput.value = select.value;
                        $WooFormCartButton.disabled = false;
                        $WooFormCartButton.click();
                    }
                }
            });
        });
    });
}